import { SharedModule } from '@shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelActivitiesComponent } from './cancel-activities/cancel-activities.component';
import { LayoutModule } from "@feature/_app_modules/layout/layout.module";

@NgModule({
  declarations: [
    CancelActivitiesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule
  ]
})
export class CancelActivitiesModule { }
